import { useState, useEffect } from "react";
import { useLocation } from "wouter";
import { BadgeCheck, X, ChevronRight } from "lucide-react";

const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, "");

interface HcpProfile {
  onboardingComplete: boolean;
  registrationVerified: boolean;
}

export function HcpVerificationBanner() {
  const [, setLocation] = useLocation();
  const [profile, setProfile] = useState<HcpProfile | null>(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("hcp_banner_dismissed") === "true");

  useEffect(() => {
    fetch(`${BASE_URL}/api/user/profile`, { credentials: "include" })
      .then(r => r.ok ? r.json() : null)
      .then(data => setProfile(data))
      .catch(() => setProfile(null));
  }, []);

  if (dismissed || !profile) return null;
  if (profile.registrationVerified) return null;

  const dismiss = () => {
    sessionStorage.setItem("hcp_banner_dismissed", "true");
    setDismissed(true);
  };

  return (
    <div className="relative z-30 bg-teal-700 text-white px-4 py-2.5 flex items-center justify-between gap-4">
      <div className="flex items-center gap-2.5 min-w-0">
        <BadgeCheck className="h-4 w-4 shrink-0 text-teal-200" />
        <p className="text-sm font-medium truncate">
          {profile.onboardingComplete
            ? "Complete your registration verification to get your Verified HCP badge."
            : "Complete your professional profile to get a Verified HCP badge."}
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={() => setLocation("/onboarding")}
          className="text-xs font-semibold bg-white text-teal-700 px-3 py-1 rounded-full flex items-center gap-1 hover:bg-teal-50 transition-colors"
        >
          Complete now <ChevronRight className="h-3 w-3" />
        </button>
        <button onClick={dismiss} className="text-teal-200 hover:text-white transition-colors">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
